import { notesRailDemoMeetingDemo } from './notesRailDemoMeetingDemo.seed'
import { notesRailDemoMeetingYou } from './notesRailDemoMeetingYou.seed'

/** @type {import('../lib/types.js').NotesRailNoteWire[]} */
export const notesRailDemoMeetingNotes = [notesRailDemoMeetingYou, notesRailDemoMeetingDemo]
